import * as REDUX_TYPES from '../types'

export const resetCreditsReducer = () => {
    return {
        type: REDUX_TYPES.CREDITS.RESET
    }
}

export const setAccruedCredits = (accruedCredits) => {
    return {
        type: REDUX_TYPES.CREDITS.ACCRUED_CREDITS,
        accruedCredits
    }
}

export const setCreditPlayTime = (creditPlayTime) => {
    return {
        type: REDUX_TYPES.CREDITS.CREDIT_PLAY_TIME,
        creditPlayTime,
    }
}

export const setCurrentArtistCredits = (currentArtistCredits) => {
    return {
        type: REDUX_TYPES.CREDITS.CURRENT_ARTIST_CREDITS,
        currentArtistCredits,
    }
}
export const setCurrentCredits = (currentCredits) => {
    return {
        type: REDUX_TYPES.CREDITS.CURRENT_CREDITS,
        currentCredits,
    }
}
export const setCurrentPromotionalCredits = (currentPromotionalCredits) => {
    return {
        type: REDUX_TYPES.CREDITS.CURRENT_PROMOTIONAL_CREDITS,
        currentPromotionalCredits,
    }
}